import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormControlNameExportDirective } from './form-control-name-export.directive';

@NgModule({
  declarations: [FormControlNameExportDirective],
  imports: [CommonModule],
  exports: [FormControlNameExportDirective],
})
export class DirectivesModule {}
